<div class="content-card fixed">
  <p><b>Панель массовых действий</b></p>
  <p>
    Компонент отображается при выборе хотя бы одной строки в таблице. На
    десктопе показывает кнопки действий, на мобильных — иконку выбора всех и
    меню с действиями под троеточием.
  </p>

  <div class="card">
    <p><b>Без пагинации</b></p>
    <!-- Панель фильтров как в tasks-list.component.html (строки 6–12) -->
    <app-filter-bar
      [config]="filterData"
      (addClick)="openEditPanel()"
      [showAddButton]="!(!hasUrlFilters && products.length === 0 && canEditTasks)"
      (filterClick)="openFilterPanel()"
    >
    </app-filter-bar>

    <pa-table
      [columns]="columns"
      [data]="products"
      [pagination]="pagination"
      [selectable]="true"
      [actions]="tableActions"
      [actionsLabel]="'Действия'"
      [bulkActions]="bulkActions"
      (selectionChange)="handleSelectionChange($event)"
      (bulkClose)="handleBulkClose()"
      (bulkToggleSelectAll)="handleToggleSelectAll($event)"
      (bulkActionClick)="handleBulkAction($event)"
    >
    </pa-table>
</div>

  <div class="card">
    <p><b>С пагинацией</b></p>

    <div class="bulk-table-container">
      <pa-table
        [columns]="columns"
        [data]="productsPaginated"
        [pagination]="paginationPaginated"
        [selectable]="true"
        [forceCardView]="false"
        [actions]="tableActions"
        [actionsLabel]="'Действия'"
        [bulkActions]="bulkActions"
        (pageChange)="handlePageChangePaginated($event)"
        (selectionChange)="handleSelectionChangePaginated($event)"
        (bulkClose)="handleBulkClosePaginated()"
        (bulkToggleSelectAll)="handleToggleSelectAllPaginated($event)"
        (bulkActionClick)="handleBulkActionPaginated($event)"
      >
      </pa-table>
    </div>
  </div>
</div>

